module.exports = __webpack_public_path__ + "2d31539c411aa5d01758c3f9ab66972c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/goMobile.png
// module id = 1809
// module chunks = 1